import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["preset"];
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.join.js";
import { resetTypographyColorVariables, typographyLight, typographyDark } from '@rescui/typography';
import { linearAnimation } from './linear-animation.js';
import presets from './presets.js';
var BURST_TIME = 300;

function parseColor(colorToParse) {
  var div = document.createElement('div');
  div.style.color = colorToParse;
  div.style.position = 'absolute';
  div.style.display = 'none';
  document.body.appendChild(div);
  var colorFromEl = getComputedStyle(div).color;
  document.body.removeChild(div);
  var parsedColor = colorFromEl.match(/^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+)\s*)?\)$/i);

  if (parsedColor) {
    var alpha = typeof parsedColor[4] === 'undefined' ? 1 : parsedColor[4];
    return [parsedColor[1], parsedColor[2], parsedColor[3], alpha];
  } else {
    console.error("Color ".concat(colorToParse, " could not be parsed."));
    return [0, 0, 0, 0];
  }
} // eslint-disable-next-line complexity


var glowHoverEffect = function glowHoverEffect(el, _ref) {
  var _options$hoverBg, _options$lightColor, _ref2, _options$lightSize, _ref3, _options$lightSizeEnt, _ref4, _options$lightSizeLea, _ref5, _options$isElementMov, _ref6, _options$customStatic, _ref7, _options$forceTypogra, _ref8, _options$enableBurst;

  var preset = _ref.preset,
      options = _objectWithoutProperties(_ref, _excluded);

  if (!el) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return function () {};
  }

  var presetCfg = {};

  if (preset) {
    var maybePreset = presets[preset];

    if (!maybePreset) {
      throw new Error("Unknown preset ".concat(preset));
    }

    presetCfg = maybePreset;
  }

  var hoverBg = (_options$hoverBg = options.hoverBg) !== null && _options$hoverBg !== void 0 ? _options$hoverBg : presetCfg.hoverBg;
  var lightColor = (_options$lightColor = options.lightColor) !== null && _options$lightColor !== void 0 ? _options$lightColor : presetCfg.lightColor;
  var lightSize = (_ref2 = (_options$lightSize = options.lightSize) !== null && _options$lightSize !== void 0 ? _options$lightSize : presetCfg.lightSize) !== null && _ref2 !== void 0 ? _ref2 : 100;
  var lightSizeEnterAnimationTime = (_ref3 = (_options$lightSizeEnt = options.lightSizeEnterAnimationTime) !== null && _options$lightSizeEnt !== void 0 ? _options$lightSizeEnt : presetCfg.lightSizeEnterAnimationTime) !== null && _ref3 !== void 0 ? _ref3 : 100;
  var lightSizeLeaveAnimationTime = (_ref4 = (_options$lightSizeLea = options.lightSizeLeaveAnimationTime) !== null && _options$lightSizeLea !== void 0 ? _options$lightSizeLea : presetCfg.lightSizeLeaveAnimationTime) !== null && _ref4 !== void 0 ? _ref4 : 50;
  var isElementMovable = (_ref5 = (_options$isElementMov = options.isElementMovable) !== null && _options$isElementMov !== void 0 ? _options$isElementMov : presetCfg.isElementMovable) !== null && _ref5 !== void 0 ? _ref5 : false;
  var customStaticBg = (_ref6 = (_options$customStatic = options.customStaticBg) !== null && _options$customStatic !== void 0 ? _options$customStatic : presetCfg.customStaticBg) !== null && _ref6 !== void 0 ? _ref6 : null;
  var forceTypographyColors = (_ref7 = (_options$forceTypogra = options.forceTypographyColors) !== null && _options$forceTypogra !== void 0 ? _options$forceTypogra : presetCfg.forceTypographyColors) !== null && _ref7 !== void 0 ? _ref7 : null;
  var enableBurst = (_ref8 = (_options$enableBurst = options.enableBurst) !== null && _options$enableBurst !== void 0 ? _options$enableBurst : presetCfg.enableBurst) !== null && _ref8 !== void 0 ? _ref8 : false;

  var getResolvedHoverBg = function getResolvedHoverBg() {
    return hoverBg !== null && hoverBg !== void 0 ? hoverBg : getComputedStyle(el).backgroundColor;
  };

  var resolvedHoverBg = getResolvedHoverBg(); // default bg (if not defined) is rgba(0, 0, 0, 0) which is bugged in gradients on safari
  // so we use transparent lightColor instead

  var parsedLightColor = parseColor(lightColor);

  var parsedLightColorRGBString = _sliceInstanceProperty(parsedLightColor).call(parsedLightColor, 0, 3).join(',');

  var resolvedGradientBg = "rgba(".concat(parsedLightColorRGBString, ",0)");
  var isMouseInside = false;
  var currentLightSize = 0;
  var blownSize = 0;
  var lightSizeEnterAnimationId = null;
  var lightSizeLeaveAnimationId = null;
  var blownSizeIncreaseAnimationId = null;
  var blownSizeDecreaseAnimationId = null;
  var lastMousePos;
  var defaultBox = el.getBoundingClientRect();
  var lastElPos = {
    x: defaultBox.left,
    y: defaultBox.top
  };

  var updateGlowEffect = function updateGlowEffect() {
    var _context, _context2, _context3, _context4, _context5, _context6;

    if (!lastMousePos) {
      return;
    }

    var gradientXPos = lastMousePos.x - lastElPos.x;
    var gradientYPos = lastMousePos.y - lastElPos.y; // we dont use transparent color here because of https://youtrack.jetbrains.com/issue/WUI-843

    var gradient = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "radial-gradient(circle at ".concat(gradientXPos, "px ")).call(_context5, gradientYPos, "px, ")).call(_context4, lightColor, " 0%, ")).call(_context3, resolvedGradientBg, " calc(")).call(_context2, blownSize * 2.5, "% + ")).call(_context, currentLightSize, "px)) no-repeat"); // we duplicate resolvedHoverBg layer here because of transition "blinking" without it (for example, Button component)


    el.style.background = _concatInstanceProperty(_context6 = "".concat(gradient, " border-box border-box ")).call(_context6, resolvedHoverBg);
  };

  var updateEffectWithPosition = function updateEffectWithPosition() {
    if (isMouseInside) {
      var curBox = el.getBoundingClientRect();
      lastElPos = {
        x: curBox.left,
        y: curBox.top
      };
      updateGlowEffect();
    }
  };

  var onMouseEnter = function onMouseEnter(e) {
    resolvedHoverBg = getResolvedHoverBg();
    lastMousePos = {
      x: e.clientX,
      y: e.clientY
    };
    var curBox = el.getBoundingClientRect();
    lastElPos = {
      x: curBox.left,
      y: curBox.top
    };
    isMouseInside = true;
    window.cancelAnimationFrame(lightSizeEnterAnimationId);
    window.cancelAnimationFrame(lightSizeLeaveAnimationId);

    if (forceTypographyColors === 'light') {
      typographyLight(el);
    } else if (forceTypographyColors === 'dark') {
      typographyDark(el);
    } // animate currentLightSize from 0 to lightSize


    linearAnimation({
      onProgress: function onProgress(progress) {
        currentLightSize = lightSize * progress;
        updateGlowEffect();
      },
      time: lightSizeEnterAnimationTime,
      initialProgress: currentLightSize / lightSize,
      onIdUpdate: function onIdUpdate(newId) {
        return lightSizeEnterAnimationId = newId;
      }
    });
  };

  var onMouseMove = function onMouseMove(e) {
    lastMousePos = {
      x: e.clientX,
      y: e.clientY
    };

    if (isElementMovable) {
      updateEffectWithPosition();
    } else {
      updateGlowEffect();
    }
  };

  var onMouseLeave = function onMouseLeave() {
    isMouseInside = false;
    window.cancelAnimationFrame(lightSizeEnterAnimationId);
    window.cancelAnimationFrame(lightSizeLeaveAnimationId);
    window.cancelAnimationFrame(blownSizeIncreaseAnimationId);
    window.cancelAnimationFrame(blownSizeDecreaseAnimationId); // animate currentLightSize from lightSize to 0

    linearAnimation({
      onProgress: function onProgress(progress) {
        currentLightSize = lightSize * (1 - progress);
        blownSize = Math.min(blownSize, (1 - progress) * 100);

        if (progress < 1) {
          updateGlowEffect();
        } else {
          el.style.background = customStaticBg ? customStaticBg : '';
        }

        if (forceTypographyColors && progress === 1) {
          resetTypographyColorVariables(el);
        }
      },
      time: lightSizeLeaveAnimationTime,
      initialProgress: 1 - currentLightSize / lightSize,
      onIdUpdate: function onIdUpdate(newId) {
        return lightSizeLeaveAnimationId = newId;
      }
    });
  };

  var onMouseDown = function onMouseDown(e) {
    lastMousePos = {
      x: e.clientX,
      y: e.clientY
    };
    var curBox = el.getBoundingClientRect();
    lastElPos = {
      x: curBox.left,
      y: curBox.top
    };
    window.cancelAnimationFrame(blownSizeIncreaseAnimationId);
    window.cancelAnimationFrame(blownSizeDecreaseAnimationId); // animate blownSize from 0 to 100

    linearAnimation({
      onProgress: function onProgress(progress) {
        blownSize = 100 * progress;
        updateGlowEffect();
      },
      time: BURST_TIME,
      initialProgress: blownSize / 100,
      onIdUpdate: function onIdUpdate(newId) {
        return blownSizeIncreaseAnimationId = newId;
      }
    });
  };

  var onMouseUp = function onMouseUp(e) {
    lastMousePos = {
      x: e.clientX,
      y: e.clientY
    };
    var curBox = el.getBoundingClientRect();
    lastElPos = {
      x: curBox.left,
      y: curBox.top
    };
    window.cancelAnimationFrame(blownSizeIncreaseAnimationId);
    window.cancelAnimationFrame(blownSizeDecreaseAnimationId); // animate blownSize from 100 to 0

    linearAnimation({
      onProgress: function onProgress(progress) {
        blownSize = (1 - progress) * 100;
        updateGlowEffect();
      },
      time: BURST_TIME,
      initialProgress: 1 - blownSize / 100,
      onIdUpdate: function onIdUpdate(newId) {
        return blownSizeDecreaseAnimationId = newId;
      }
    });
  };

  document.addEventListener('scroll', updateEffectWithPosition);
  window.addEventListener('resize', updateEffectWithPosition);
  el.addEventListener('mouseenter', onMouseEnter);
  el.addEventListener('mousemove', onMouseMove);
  el.addEventListener('mouseleave', onMouseLeave);

  if (enableBurst) {
    el.addEventListener('mousedown', onMouseDown);
    el.addEventListener('mouseup', onMouseUp);
  }

  var resizeObserver;

  if (window.ResizeObserver) {
    resizeObserver = new ResizeObserver(updateEffectWithPosition);
    resizeObserver.observe(el);
  }

  return function () {
    window.cancelAnimationFrame(lightSizeEnterAnimationId);
    window.cancelAnimationFrame(lightSizeLeaveAnimationId);
    window.cancelAnimationFrame(blownSizeIncreaseAnimationId);
    window.cancelAnimationFrame(blownSizeDecreaseAnimationId);
    document.removeEventListener('scroll', updateEffectWithPosition);
    window.removeEventListener('resize', updateEffectWithPosition);
    el.removeEventListener('mouseenter', onMouseEnter);
    el.removeEventListener('mousemove', onMouseMove);
    el.removeEventListener('mouseleave', onMouseLeave);

    if (enableBurst) {
      el.removeEventListener('mousedown', onMouseDown);
      el.removeEventListener('mouseup', onMouseUp);
    }

    if (forceTypographyColors) {
      resetTypographyColorVariables(el);
    }

    if (resizeObserver) {
      resizeObserver.unobserve(el);
      resizeObserver.disconnect();
    }
  };
};

export { glowHoverEffect, parseColor };
